import { useApiClient } from '../../api/useApiClient';

class RetentionPolicyService {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.apiBase = '/api/v1/retention-policies';
    }

    getPolicies() {
        return this.apiClient.get(this.apiBase);
    }

    getPolicy(id) {
        return this.apiClient.get(`${this.apiBase}/${id}`);
    }

    createPolicy(data) {
        return this.apiClient.post(this.apiBase, data);
    }

    updatePolicy(id, data) {
        return this.apiClient.put(`${this.apiBase}/${id}`, data);
    }

    deletePolicy(id) {
        return this.apiClient.delete(`${this.apiBase}/${id}`);
    }

    activatePolicy(id) {
        return this.apiClient.post(`${this.apiBase}/${id}/activate`);
    }

    deactivatePolicy(id) {
        return this.apiClient.post(`${this.apiBase}/${id}/deactivate`);
    }

    associatePolicy(idPolicy, idTipoDoc) {
        return this.apiClient.post(`${this.apiBase}/${idPolicy}/associate/${idTipoDoc}`);
    }

    dissociatePolicy(idPolicy, idTipoDoc) {
        return this.apiClient.post(`${this.apiBase}/${idPolicy}/dissociate/${idTipoDoc}`);
    }

    getPoliciesByTipoDoc(idTipoDoc) {
        return this.apiClient.get(`/api/v1/series/${idTipoDoc}/retention-policies`);
    }
}

export const useRetentionPolicyService = () => {
    const apiClient = useApiClient();
    return new RetentionPolicyService(apiClient);
};

export default RetentionPolicyService;
